import React from 'react'
import { MaintenanceHistoryDetails } from '../../types/maintenance'
import { InfoListItem } from '@brightlayer-ui/react-components'
import * as PXBColors from '@brightlayer-ui/colors';
import { Divider, IconButton, ListItemText, Typography } from '@mui/material';
import { ChevronRight } from '@mui/icons-material';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { getServiceType } from '../enum/ENUM';
import { formatDate, formatTime } from '../enum/CommonFunction';
import StatusError from '../../assets/images/status_error.svg';
import ContactSupport from "../../assets/images/contact_support.svg";
import Maintenance from "../../assets/images/build.svg"

type Props = {
    data: MaintenanceHistoryDetails
    displayClick: Function;
}


const MaintenanceHistoryListItem: React.FC<React.PropsWithChildren<React.PropsWithChildren<Props>>> = (props: Props) => {

    const { t } = useLanguageLocale();
    const row: MaintenanceHistoryDetails = props.data;
    function getStatusIcon(icon: any) {
        switch (icon) {
            case 1:
                return StatusError;
            case 2:
                return Maintenance;
            case 3:
                return ContactSupport;
            default:
                return ""
        }
    }

    const handleDisplay = () => {
        props.displayClick({ maintenance: props.data });
    };

    return (
        <div>
            <InfoListItem
                id="maintenace-history-list-item"
                style={{ height: 'auto', flexFlow: 'row wrap' }}
                translate="no"
                avatar={false}
                placeholder={undefined}
                icon={<img alt={'Status'} src={getStatusIcon(props.data.serviceType)} style={{ width: 24, height: 24 }} />}
                title=""
                backgroundColor={PXBColors.white[50]}
                leftComponent={<>
                    <div style={{ marginRight: '10' }}>
                        <Typography>
                            {formatTime(props.data.completionDate)}
                        </Typography>
                        <Typography>
                            {formatDate(props.data.completionDate)}
                        </Typography>
                    </div>
                    <ListItemText style={{ marginLeft: "7%" }}>
                        <Typography
                            id='maintenance-history-title-name'
                            style={{ fontWeight: 600, fontSize: 16 }}>
                            {props.data.customerName}
                        </Typography>
                        <Typography
                            display="block"
                            style={{
                                lineHeight: 1.25,
                                fontWeight: 400,
                                fontSize: 14,
                            }}
                        >
                            {t(getServiceType(props.data.serviceType ?? 0))}
                        </Typography>
                        <Typography
                            display="block"
                            sx={{
                                lineHeight: 1.25,
                                textOverflow: 'ellipsis',
                                display: '-webkit-box',
                                WebkitLineClamp: 1,
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                wordWrap: 'break-word'
                            }}
                            style={{
                                fontSize: 14,
                                fontWeight: 300
                            }}
                        >
                            {t('MAINTENANCE_DETAILS.TECHNICAN')}:{props.data.technicianName}
                        </Typography>
                        <Typography
                            sx={{ fontSize: 12, fontWeight: 300 }}
                        >
                            {t('MAINTENANCE_DETAILS.TICKET_NO_')} {props.data.ticketNumber}
                        </Typography>
                    </ListItemText>
                </>}
                rightComponent={<>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                    }}>

                        <IconButton
                            data-testid="next-button-logs"
                            onClick={() => handleDisplay()}
                        >
                            <ChevronRight id="system-log-list-item-next-icon" />
                        </IconButton>
                    </div>

                </>}
            />
            <Divider style={{ marginLeft: 72 }} />
        </div>
    )
}

export default MaintenanceHistoryListItem
